import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import T from 'prop-types';

import ErrorStateWithReload from '../../../../components/ErrorStateWithReload';
import { requestSingleAsset } from '../../../../store';

const SectionErrorWithReload = ({ assetName, subAssets, className }) => {
  const dispatch = useDispatch();

  const handleRefresh = useCallback(() => {
    dispatch(requestSingleAsset(assetName, {}, subAssets));
  }, [assetName, subAssets]);

  return (
    <ErrorStateWithReload
      className={className}
      buttonText="Refresh Section"
      onRefresh={handleRefresh}
    />
  );
};

SectionErrorWithReload.propTypes = {
  assetName: T.string.isRequired,
  subAssets: T.array.isRequired,
  className: T.string,
};

export default SectionErrorWithReload;
